import {
    Tabs,
    Tab,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const Container = styled('div')({
    padding: '30px',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    overflow: 'auto',
});

export const CardCount = styled('span')({
    fontSize: '2rem',
    fontWeight: 600,
    color: 'var(--primary-main)',
});

export const StyledTabs = styled(Tabs)({
    marginBottom: '20px',

    '& .MuiTabs-indicator': {
        backgroundColor: 'var(--secondary-main)',
    },
});

export const StyledTab = styled(Tab)({
    '&.Mui-selected': {
        color: 'var(--secondary-main)',
    },
});